import {createSlice} from "@reduxjs/toolkit";
import React from "react";

const appDialogSlice = createSlice({
    name: "appDialog",
    initialState: {
        isVisible: false,
    },
    reducers:{
        setAppDialog: (state, action={}) => {
            let payload = action.payload;
            
            if(payload.closable === undefined)
               payload.closable = true;

            // if (!payload.title)
            //    payload.title = "Error";
            
            if (!payload.content)
               payload.content = <React.Fragment></React.Fragment>;

            //if (payload.actions && !payload.actions.yesButton)
                //payload.actions.yesButton = {title: "Close"};
                
            return ({...payload});            
        },
        hideAppDialog: (state, action) => ({isVisible: false})
    }
});

export const { setAppDialog, hideAppDialog } = appDialogSlice.actions;

export default appDialogSlice.reducer;
